import React from 'react';
import _ from 'lodash';
import './index.scss';
import { useTranslation } from 'react-i18next';
import Scrollbar from 'react-scrollbars-custom';

const TrendingDrugs = ({ data }) => {
  const { i18n, t } = useTranslation();
  return (
    <div className="trendingDrugs">
      <h2>{t('Trending on SingleCare')}</h2>
      <Scrollbar style={{ width: 900, height: 96 }}>
        <ul>
          {data?.drugs?.length > 0 &&
            data?.drugs.map((drug, index) => {
              return (
                <li key={`drug-${index}`}>
                  <a
                    href={`${_.withLocale(i18n.language, '/prescription')}/${
                      drug.seoName
                    }`}
                  >
                    {drug.name}
                  </a>
                </li>
              );
            })}
        </ul>
      </Scrollbar>
    </div>
  );
};

export default TrendingDrugs;
